const nodeUrl = process.env.NEXT_PUBLIC_NODE_API_URL;

//* 앱스토어 링크
export const iosLink = "https://apps.apple.com/kr/app/%EB%AF%B8%EC%8A%A4%EA%B3%A0/id1637542873";
//* 구글플레이스토어 링크
export const aosLink = "https://play.google.com/store/apps/details?id=com.missgoauction.missgoauction";
//* 미스고 유튜브 링크
export const youtubeLink = "https://youtu.be/HkQ7kn2tZcA";
//* 미스고 네이버 블로그 링크
export const blogLink = "https://blog.naver.com/missgoauction";
//* 미스고 카카오 플러스 친구 링크
export const kakaoLink = "http://pf.kakao.com/_HxbrXxj";
//* 미스고 인스타그램 링크
export const instagramLink = "https://www.instagram.com/p/Ck3p_--vQKS/?igshid=MDJmNzVkMjY=";
//* 미스고 네이버 포스트 링크
export const postLink = "https://m.post.naver.com/missgoauction";
//* 미스고 nice 본인인증
export const certLink = `${nodeUrl}/userCI/checkplus_main`;

//! 약관
const termUrl = process.env.NEXT_PUBLIC_URL;

//* 개인정보 처리방침
export const privacyTerm = `${termUrl}/Policy/Privacy/index.html`;
//* 서비스 이용약관
export const serviceTerm = `${termUrl}/Policy/Service/index.html`;
//* 개인정보 수집 및 이용 동의
export const collectionConsentTerm = `${termUrl}/Policy/CollectionConsent/index.html`;
//* 위치기반 서비스 이용약관 동의
export const LocationServiceTerm = `${termUrl}/Policy/LocationService/index.html`;
//* 매물정보 및 광고성 정보 수신 동의
export const marketingTerm = `${termUrl}/Policy/MarketingConsent/index.html`;
//* 유료서비스 이용약관
export const payServiceTerm = `${termUrl}/Policy/PayService/index.html`;
//* 유료서비스 이용약관
export const paymentPrivacyTerm = `${termUrl}/Policy/PaymentPrivacy/index.html`;
